import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andWhere,
  buildQuery,
  Ops,
  orderBy,
  OrderVariant,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import { IResult } from "../../../../../common/interfaces";
import { environment as env } from "../../../../../../environments/environment.prod";
import { BusinessPartnerScheduleAttributes, ScheduleTypeEnum } from "@albatrosdeveloper/ave-models-package";
import { ICreateBusinessPartnerSchedule } from "./interfaces/create-business-partner-schedule.interface";
import { IUpdateBusinessPartnerSchedule } from "./interfaces/update-business-partner-schedule.interface";
import { AbstractService } from "app/services/abstract.service";

const apiUrl = env.API_BUSINESS_PARTNER;
const moduleName = "business-partner-schedule";

@Injectable({
  providedIn: "root",
})
export class BusinessPartnerScheduleService extends AbstractService<
  BusinessPartnerScheduleAttributes,
  ICreateBusinessPartnerSchedule,
  IUpdateBusinessPartnerSchedule
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  findByBusinessPartnerId(
    bpId: number,
    type: ScheduleTypeEnum,
  ): Observable<IResult<BusinessPartnerScheduleAttributes>> {
    const query = buildQuery<BusinessPartnerScheduleAttributes>(
      where("_deleted", Ops.eq(false)),
      andWhere("businessPartnerId", Ops.eq(bpId)),
      andWhere("type", Ops.eq(type)),
      orderBy("day", OrderVariant.Asc)
    );

    const API_URL: string = `${apiUrl}api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IResult<BusinessPartnerScheduleAttributes>>(API_URL);
  }
}
